import { ListItem, styled } from '@mui/material';
import { StyledBrandListItemProps, StyledSelectedListItemProps } from './BrandOrderListItem.types';

export const StyledUnselectedListItem = styled(ListItem, {
  shouldForwardProp: prop => prop !== 'isMobile'
})<StyledBrandListItemProps>(({ isMobile, theme }) => ({
  border: '1px solid #e0e0e0',
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(0.5),
  minHeight: isMobile ? 56 : 40,
  paddingTop: isMobile ? theme.spacing(1) : theme.spacing(0.5),
  paddingBottom: isMobile ? theme.spacing(1) : theme.spacing(0.5),
  backgroundColor: '#f5f5f5',
  opacity: 0.7
}));

export const StyledSelectedListItem = styled(ListItem, {
  shouldForwardProp: prop => !['isDragging', 'isVisible', 'isOkko', 'isMobile'].includes(prop as string)
})<StyledSelectedListItemProps>(({ isDragging, isVisible, isOkko, isMobile }) => ({
  border: isDragging ? '2px solid rgb(132, 189, 0)' : '1px solid #e0e0e0',
  borderRadius: 8,
  marginBottom: 4,
  minHeight: isMobile ? 56 : 40,
  paddingTop: isMobile ? 8 : 4,
  paddingBottom: isMobile ? 8 : 4,

  backgroundColor: isDragging ? 'rgba(132, 189, 0, 0.2)' : isOkko ? '#e8f5e8' : 'white',
  opacity: isDragging ? 0.9 : isVisible ? 1 : 0.5,
  cursor: isVisible && !isOkko ? 'grab' : 'default',
  transition: 'all 0.2s ease',
  transform: isDragging ? 'scale(1.05)' : 'none',
  boxShadow: isDragging ? '0 4px 12px rgba(132, 189, 0, 0.3)' : 'none',
  '&:active': {
    cursor: isVisible && !isOkko ? 'grabbing' : 'default'
  },
  '&:hover': {
    backgroundColor: !isDragging && isVisible ? (isOkko ? '#d4edda' : '#f8f9fa') : undefined
  }
}));
